import { type JSX } from 'react/jsx-runtime';
import rovoIconImage from './rovo-icon.png';

export const ROVO_ICON = (): JSX.Element => (
	<img src={rovoIconImage} alt="Rovo" width={32} height={32} />
);
